import { configureStore as configureStoreRedux } from '@reduxjs/toolkit';
import { FLUSH, PAUSE, PERSIST, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist';
import { rootReducer } from './modules';
import sentry from './middleware/sentry';

// Disable redux devtools during testing and in production.
const envs = ['production', 'test'];
const devTools = !envs.includes(process.env.NODE_ENV as string);

const configureStore = (state = {}) => {
  const store = configureStoreRedux({
    reducer: rootReducer,
    preloadedState: state,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }),
    devTools,
    enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(sentry),
  });
  const persistor = persistStore(store);
  return { store, persistor };
};

export default configureStore;
